var _path, _path2, _path3, _path4, _path5, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconEffortlessPrivacy(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M53.4466 30.9132C53.1087 28.7083 52.5802 13.4833 36.7844 11.4004C31.0743 10.6596 17.4448 11.566 12.7918 21.2309C9.23062 28.6386 9.51656 38.1204 14.5248 43.8897C32.3134 64.1258 55.7168 45.5717 53.4466 30.9132Z",
    fill: "#F1F1F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46.9411 36.1869C29.8472 53.548 14.4 33.2082 14.4 33.2082C14.4 33.2082 20.4039 20.7998 32 20.7998C43.5961 20.7998 49.6 33.2082 49.6 33.2082C49.6 33.2082 36.6916 19.7511 20.6526 29.877",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M28 34.3605C28.0096 33.3809 28.3785 32.4389 29.0365 31.7132C29.6945 30.9874 30.596 30.5284 31.57 30.4231C32.544 30.3178 33.5228 30.5736 34.3207 31.142C35.1187 31.7104 35.6802 32.5518 35.899 33.5067C36.1177 34.4617 35.9785 35.4637 35.5075 36.3227C35.0366 37.1817 34.2668 37.8381 33.3441 38.1673C32.4214 38.4965 31.4099 38.4756 30.5016 38.1087C29.5932 37.7418 28.8511 37.0542 28.416 36.1765",
    stroke: "#00005A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9076 42.6158L12.3144 50.209L13.5381 51.4327L21.1313 43.8395L19.9076 42.6158Z",
    fill: "url(#paint0_linear)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4094 12.1134L42.8162 19.7065L44.0399 20.9303L51.6331 13.3371L50.4094 12.1134Z",
    fill: "url(#paint1_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 20.3429,
    y1: 42.9977,
    x2: 13.109,
    y2: 51.0363,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FF44FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "#4900FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00005A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 43.6089,
    y1: 20.548,
    x2: 50.8428,
    y2: 12.5093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF9F8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#FF9793"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#FF8AA4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FF80B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#FF66D2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4,
    stopColor: "#FF44FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#4900FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00005A"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconEffortlessPrivacy);
export default __webpack_public_path__ + "static/media/icon-effortless-privacy.7b9b58d01e8abb8b24fa2bc31b030b11.svg";
export { ForwardRef as ReactComponent };